// extracted by mini-css-extract-plugin
module.exports = {"background":"Yz-gl","container":"wIpiD","dialogue":"lvvao"};